export default __webpack_public_path__ + "static/media/plan-tick-circle.ac13538f.svg";